import _cloneDeep from "lodash/cloneDeep";
import { AnyAction } from "redux";
import { PhoneNumbersState } from "../../../../../models/state";
import * as CHECKOUT_AT from "../../../checkout/state/actionTypes";
import { fulfilled } from "../../utils";
import * as AT from "../actionTypes";

const initialState = (): PhoneNumbersState => ({
    available: [],
    messages: [],
});

const reducer = (state = initialState(), action: AnyAction): PhoneNumbersState => {
    switch (action.type) {
        case fulfilled(CHECKOUT_AT.CHECKOUT_CHECK_NEW_MEMBER_PHONE_NUMBER): {
            const subscriptionId = action.payload.id || action.payload.messages[0]?.subscriptionId;
            const existingMessages =
                _cloneDeep(state.messages)?.filter((message) => message.subscriptionId !== subscriptionId) || [];
            return {
                ...state,
                messages: [...existingMessages, ...action.payload.messages],
                availablePricePlans: subscriptionId
                    ? {
                          ...state.availablePricePlans,
                          [subscriptionId]: action.payload.availablePricePlans ?? [],
                      }
                    : state.availablePricePlans,
                availableIcims: subscriptionId
                    ? {
                          ...state.availableIcims,
                          [subscriptionId]: action.payload.availableIcims ?? {},
                      }
                    : state.availableIcims,
                breakageFeeAmounts: subscriptionId
                    ? {
                          ...state.breakageFeeAmounts,
                          [subscriptionId]: action.payload.breakageFeeAmount ?? 0,
                      }
                    : state.breakageFeeAmounts,
                canKeepCurrentPricePlan: subscriptionId
                    ? {
                          ...state.canKeepCurrentPricePlan,
                          [subscriptionId]: !!action.payload.canKeepCurrentPricePlan,
                      }
                    : state.canKeepCurrentPricePlan,
                offeringsCreditRequirements: subscriptionId
                    ? {
                          ...state.offeringsCreditRequirements,
                          [subscriptionId]: action.payload.offeringsCreditRequirements ?? {},
                      }
                    : state.offeringsCreditRequirements,
            };
        }
        case fulfilled(AT.RETAILER_FETCH_PRICE_PLANS_FOR_EDIT): {
            const subscriptionId = action.payload?.id;
            if (!subscriptionId) return state;
            return {
                ...state,
                availablePricePlans: {
                    ...state.availablePricePlans,
                    [subscriptionId]: action.payload.availablePricePlans ?? [],
                },
                availableIcims: {
                    ...state.availableIcims,
                    [subscriptionId]: action.payload.availableIcims ?? {},
                },
                offeringsCreditRequirements: {
                    ...state.offeringsCreditRequirements,
                    [subscriptionId]: action.payload.offeringsCreditRequirements ?? {},
                },
                canKeepCurrentPricePlan: {
                    ...state.canKeepCurrentPricePlan,
                    [subscriptionId]: !!action.payload.canKeepCurrentPricePlan,
                },
            };
        }
        case fulfilled(AT.RETAILER_FETCH_AVAILABLE_PHONE_NUMBERS):
            return {
                ...state,
                available: action.payload,
            };
        case AT.RETAILER_CHOOSE_PHONE_NUMBER_SWITCH_PANEL:
            return {
                ...state,
                selectedPanel: action.activePanel,
            };
        case AT.RETAILER_RESET_CURRENT_PHONE_NUMBER_CHECK_MESSAGES: {
            const { id } = action;
            const filteredMessages = id ? state.messages?.filter((message) => message.subscriptionId !== id) : [];
            return {
                ...state,
                messages: filteredMessages,
            };
        }
        default:
            return state;
    }
};

export default reducer;
